import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreatePaymentAccount(
    $businessType: String!
    $country: String!
    $currency: String!
    $legalEntityName: String
    $firstName: String
    $lastName: String
    $nickname: String!
    $processor: String!
    $scopeId: Int!
    $scopeType: String!
    $payoutDescriptor: String
    $dateOfBirth: String
    $addressLine1: String
    $addressLine2: String
    $addressPostalCode: String
    $addressCity: String
    $addressState: String
    $representativeFirstName: String
    $representativeLastName: String
    $representativeAddressLine1: String
    $representativeAddressLine2: String
    $representativeAddressPostalCode: String
    $representativeAddressCity: String
    $representativeAddressState: String
    $isMerchant: Boolean
  ) {
    createPaymentAccount(
      input: {
        business_type: $businessType
        country: $country
        currency: $currency
        nickname: $nickname
        scope_id: $scopeId
        scope_type: $scopeType
        processor: $processor
        legal_entity_name: $legalEntityName
        first_name: $firstName
        last_name: $lastName
        payout_descriptor: $payoutDescriptor
        address_line1: $addressLine1
        address_line2: $addressLine2
        address_postal_code: $addressPostalCode
        address_city: $addressCity
        address_state: $addressState
        representative_first_name: $representativeFirstName
        representative_last_name: $representativeLastName
        representative_address_line1: $representativeAddressLine1
        representative_address_line2: $representativeAddressLine2
        representative_address_postal_code: $representativeAddressPostalCode
        representative_address_city: $representativeAddressCity
        representative_address_state: $representativeAddressState
        date_of_birth: $dateOfBirth
        is_merchant: $isMerchant
      }
    ) {
      bankAccountNumberLast4
      bankName
      bankRoutingNumber
      businessType
      country
      currency
      currentProcessorAccountId
      id
      insertedAt
      legalEntityName
      firstName
      lastName
      nickname
      paymentsEnabled
      payoutsEnabled
      processor
      scopeId
      scopeType
      paymentDescriptor
      payoutDescriptor
      status
    }
  }
`;
